import React from 'react';

interface NotificationIconProps {
  badgeCount?: number;
  width?: number | string;
  height?: number | string;
}

const NotificationIcon: React.FC<NotificationIconProps> = ({
  badgeCount,
  width = 20,
  height = 20
}) => {
  const showBadge = typeof badgeCount === 'number' && badgeCount > 0;
  const displayCount = showBadge
    ? badgeCount! > 99
      ? '99+'
      : String(badgeCount)
    : '';

  // Badge styling based on Figma: #F43350 background, white border, Inter font
  const badgeOffset = -6; // Position from top-right
  const badgeSize = 16; // Fixed circle; smaller type when count needs more room
  const isSingleDigit = displayCount.length === 1;
  const badgeFontSize = isSingleDigit ? 10 : displayCount.length === 2 ? 8 : 7; // "99+"

  return (
    <span
      style={{
        position: 'relative',
        display: 'inline-flex'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width as number}
        height={height as number}
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M17.7867 12.6758C17.6182 12.3672 17.4458 12.0684 17.2754 11.7734C16.4488 10.3389 15.7344 9.10059 15.7344 7.15332C15.7344 4.03418 13.1968 1.49609 10.0772 1.49609C6.95755 1.49609 4.41995 4.03418 4.41995 7.15332C4.41995 8.91992 3.66116 10.2022 2.85794 11.5586C2.63773 11.9307 2.41653 12.3047 2.20853 12.6895C1.83255 13.3857 1.8516 14.21 2.25931 14.8936C2.67142 15.584 3.39603 15.9961 4.19779 15.9961H7.25004C7.25004 17.5127 8.48344 18.7461 10 18.7461C11.5166 18.7461 12.75 17.5127 12.75 15.9961H15.8052C16.6084 15.9961 17.3331 15.583 17.7442 14.8906C18.1519 14.2031 18.168 13.375 17.7867 12.6758ZM10 17.2461C9.31059 17.2461 8.75004 16.6855 8.75004 15.9961H11.25C11.25 16.6855 10.6895 17.2461 10 17.2461ZM16.4541 14.125C16.3877 14.2363 16.1919 14.4961 15.8052 14.4961H4.1978C3.92925 14.4961 3.68608 14.3574 3.54741 14.125C3.48296 14.0166 3.3521 13.7295 3.52886 13.4023C3.7271 13.0342 3.93853 12.6777 4.14849 12.3232C5.01958 10.8525 5.91997 9.33105 5.91997 7.15332C5.91997 4.89941 7.82378 2.99609 10.0772 2.99609C12.3306 2.99609 14.2344 4.89941 14.2344 7.15332C14.2344 9.50195 15.1197 11.0371 15.9761 12.5225C16.1407 12.8076 16.3067 13.0957 16.4698 13.3945C16.6504 13.7256 16.5191 14.0156 16.4541 14.125Z"
          fill="#222222"
        />
      </svg>
      {showBadge && (
        <span
          style={{
            position: 'absolute',
            top: badgeOffset,
            right: badgeOffset,
            width: badgeSize,
            height: badgeSize,
            minWidth: badgeSize,
            minHeight: badgeSize,
            padding: 0,
            borderRadius: '50%',
            background: '#F43350',
            border: '2px solid #F8F8F8',
            color: '#FFFFFF',
            fontFamily: 'Inter, sans-serif',
            fontSize: badgeFontSize,
            fontWeight: 600,
            lineHeight: '1',
            textAlign: 'center',
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          aria-label={`${displayCount} alerts`}
        >
          {displayCount}
        </span>
      )}
    </span>
  );
};

export default NotificationIcon;
